<template>
  <v-img contain src="@/assets/Blow out services.svg" width="34" height="34" />
</template>

<script>
  export default {
    name: 'BlowOutServices'
  }
</script>
